export const SIP_SERVER = 'call.bistux.com:9080'
export const BASE_URL = 'https://api.frejun.com/api/v1'
export const REGISTRATION_EXPIRES = 60;